import {Component, Prop, Vue} from "vue-property-decorator";
import {Notification} from "~/modules/notifications/lib/notification";
import {HTMLSanitizer} from "~/components/html-sanitizer";
import {Scroller} from "~/components/scroller";
import {Modal} from "~/components/modal";

@Component
export class NotificationModal extends Vue {

  @Prop({type: Object, required: true}) notification: Notification;
  protected isLoading = false;

  async created(){
    this.isLoading = true;
    await this.notification.loadContent();
    this.isLoading = false;
  }

  renderContent() {
    if (this.isLoading) return <p>Chargement</p>;
    if (!this.notification.content) return <p>Aucun contenu</p>
    return <HTMLSanitizer class="content" html={this.notification.content}/>;
  }

  render() {
    return (
      <Modal class="modal-notification-content" isActive onClose={() => this.$emit("close")}>
        <div class="box">
          <Scroller class="modal-notification-content_scroller">
            <div> {this.renderContent()}</div>
          </Scroller>
        </div>
      </Modal>
    );
  }
}
// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-7950a323/notification-preview.tsx" });